// React Router v7 future flags configuration
// Future flags configuration for React Router (v7)
export const routerFutureConfig = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

export default routerFutureConfig;
